import { useAppDispatch } from "@lib/stores";
import { apiClient } from "@modules/api";
import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";
import { Server } from "@wajeez/wajeez.microservices";
import { useCallback, useEffect } from "react";

export const useB2BEvents = () => {
  const commonDispatch = useAppDispatch();

  const AICC_SID = getQueryFromUrl("AICC_SID");
  const AICC_URL = getQueryFromUrl("AICC_URL");

  const setHikmaStudent = useCallback(async () => {
    try {
      if (AICC_SID && AICC_URL) {
        const client = new Server.Server_Auth_Client(undefined, apiClient);

        await client.auth_Hikma_SetStudentId__V1(AICC_SID, AICC_URL);
      }
    } catch (error: any) {
      //   const errors = JSON.parse(error.response).errors;
      //
      //   commonDispatch(
      //     CommonActions.setAlert({
      //       show: false,
      //       for: 'page',
      //       type: AlertType.ERROR,
      //       messages: errors || [{ message: 'Something went wrong' }],
      //     })
      //   );
    }
  }, [AICC_SID, AICC_URL, commonDispatch]);

  useEffect(() => {
    setHikmaStudent();
  }, [AICC_SID, AICC_URL, setHikmaStudent]);
};
